<template>
  <div v-if="isFullScreenLoading" class="full-overlay">
    <span class="spinner-border text-light spinner-overlay" role="status" aria-hidden="true"></span>
  </div>
  <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing">
    <div class="card-head box-shadow bg-white">
      <div class="row px-3 py-2">
        <div class="mt-20 col-12 col-md-4">
          <form class="search-box position-relative">
            <input
              type="text"
              class="form-control shadow-none text-black rounded-0 border-0"
              placeholder="Search Customer"
              v-model="searchInput"
            />
            <button
              class="bg-transparent text-primary transition p-0 border-0"
              disabled
            >
              <i class="flaticon-search-interface-symbol"></i>
            </button>
          </form>
        </div>
        <div class="col row">
          
        </div>
      </div>
    </div>
    <!-- Existing template code -->
    <div class="card-body p-15 p-sm-20 p-md-25 position-relative">
      <div v-if="isLoading" class="relative-overlay">
        <span class="spinner-border text-light spinner-overlay" role="status" aria-hidden="true"></span>
      </div>
      <div class="table-responsive">
        <table class="table text-nowrap align-middle mb-0">
          <thead>
            <tr>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              >
                <SortableColumn column="id" :sortedBy="sortField" @sortClicked="sortClicked">ID</SortableColumn>
              </th>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              >
                <SortableColumn column="name" :sortedBy="sortField" @sortClicked="sortClicked">Name</SortableColumn>
              </th>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              >
                <SortableColumn column="email" :sortedBy="sortField" defaultOrder='asc' @sortClicked="sortClicked">Email</SortableColumn>
              </th>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              >
                Primary Shipping Location
              </th>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              >
                <SortableColumn column="created_at" :sortedBy="sortField" @sortClicked="sortClicked">Created at</SortableColumn>
              </th>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text-end pe-0"
              >
                Actions
                </th>
            </tr>
          </thead>

          <tbody v-if="customers.length">
            <tr v-for="customer in customers" :key="customer.id">
              <td><router-link :to="{ name: 'WholesaleCustomerDetailsPage', params: { customer_id: customer.id } }">{{ customer.id }}</router-link></td>
              <td>{{ customer.name }}</td>
              <td>{{ customer.email }}</td>
              <td>
                <address v-if="customer.primary_shipping_address">{{ customer.primary_shipping_address.data.city }}, {{ customer.primary_shipping_address.data.state_or_region }}</address>
                <address v-if="!customer.primary_shipping_address">–</address>
              </td>
              <td>{{ formatTimestamp(customer.created_at) }}</td>
              <td class="shadow-none lh-1 fw-medium text-paragraph text-end pe-0" >
                <div class="dropdown">
                  <button
                    class="dropdown-toggle lh-1 bg-transparent border-0 shadow-none p-0 transition"
                    type="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    <i class="flaticon-dots"></i>
                  </button>
                  <ul class="dropdown-menu">
                    <li v-if="customer.primary_shipping_address">
                      <router-link
                        :to="{path: '/wholesale/customers/'+customer.id+'/new-order' }"
                        class="dropdown-item d-flex align-items-center"
                        ><i
                          class="ph ph-shopping-cart lh-1 me-8 position-relative top-1"
                        ></i>
                        New Order</router-link
                      >
                    </li>
                    <!-- <li>
                      <router-link
                        :to="{path: '/wholesale/customers/'+customer.id }"
                        class="dropdown-item d-flex align-items-center"
                        ><i
                          class="flaticon-pen lh-1 me-8 position-relative top-1"
                        ></i>
                        Edit</router-link
                      >
                    </li> -->
                    <li>
                      <a
                        class="dropdown-item d-flex align-items-center cursor-pointer"
                        data-bs-toggle="modal" data-bs-target="#confirmDeleteModal" :data-product-uid="customer.id"
                        @click.prevent="removeCustomerClicked(customer)"
                        ><i
                          class="flaticon-delete lh-1 me-8 position-relative top-1"
                        ></i>
                        Delete</a
                      >
                    </li>
                  </ul>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <PaginationFooter :pagination="meta.pagination" :sortField="sortField" :sortOrder="sortOrder" :search="searchInput" />
    </div>
  </div>

  <!-- Modal -->
  <div class="modal fade" id="confirmDeleteModal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h1 class="modal-title fs-5">Removing the Customer "<span class="text-danger deleteModalCustomerName"></span>". Confirm?</h1>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <div class="row">
            <p>Once this action is confirmed it cannot be undone, are you sure you want to delete the customer?</p>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" id="closeCofirmDeleteModal" class="btn btn-outline-secondary" data-bs-dismiss="modal">Close</button>
          <button type="button" v-on:click="deleteCustomer()" class="btn btn-outline-danger">Delete</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { updatePageUrlWithSearch, currentPage, formatTimestamp } from "../../utils/helper";
import SortableColumn from "../Common/SortableColumn.vue";
import PaginationFooter from "../Common/PaginationFooter.vue";
import apiConnector from '../../utils/apiConnector';
import showToast from '/src/utils/showToast';
import { Modal } from "bootstrap";
import $ from "jquery";

export default {
  name: "CustomersList",
  components: {
    SortableColumn,
    PaginationFooter
  },
  data() {
    return {
      isLoading: false,
      customerToDelete: null,
      isFullScreenLoading: false,
      sortField: 'created_at',
      sortOrder: 'desc',
      customers: [],
      // fulfillmentStatuses: [
      //   {id: 1, name: 'Pending'},
      //   {id: 2, name: 'Picking'},
      //   {id: 3, name: 'QC Complete'},
      //   {id: 5, name: 'Shipped'},
      //   {id: 6, name: 'On Hold'},
      //   {id: 7, name: 'Cancelled'},
      //   {id: 8, name: 'Backordered'},
      //   {id: 9, name: 'Packed'},
      //   {id: 10, name: 'Pending PickUp'},
      //   {id: 12, name: 'Partially Shipped'},
      // ],
      searchInput: '',
      meta: {
        pagination: {
          total: 0,
          count: 0,
          per_page: 20,
          current_page: 1,
          total_pages: 1,
          links: {
            next: null,
            previous: null,
          },
        },
      },
    };
  },
  watch: {
    // Watch the entire route for changes in query parameters
    '$route.query': {
      immediate: true,
      handler(newQuery) {
        this.selectedAll = false;
        this.sortField = newQuery.sort_by || 'created_at';
        this.sortOrder = newQuery.sort_order || 'desc';
        this.searchInput = newQuery.q || '';
        this.fetchWholesaleCustomers();
      },
    },
    searchInput(search){
      updatePageUrlWithSearch(1, this.sortField, this.sortOrder, search);
    }
  },
  methods: {
    async fetchWholesaleCustomers() {
  
      this.isLoading = true;

      let url = `/merchant-wholesale-customers?&page=${currentPage()}&sorting[${this.sortField}]=${this.sortOrder}`;

      // if (this.fulfillmentStatus != 'all') url += `&filter[fulfillment_status]=${encodeURIComponent(this.fulfillmentStatus)}`;
      if (this.searchInput) url += `&q=${encodeURIComponent(this.searchInput)}`;

      try {
        const response = await apiConnector.makeGetRequest(url);
        
        this.customers = response.data.data;
        this.meta = response.data.meta;

        // this.$router.replace({ path: this.$route.path, query: { q, page, 'filter[fulfillment_status]': fulfillmentStatus, sorting: { [this.sortField]: this.sortOrder } } }).catch(err => { console.log(err); });

      } catch (error) {
        console.error('There was an error fetching the customers:', error);
        this.customers = [];
        this.meta = { pagination: { total: 0, count: 0, current_page: 1, total_pages: 1, links: { next: null, previous: null } } };
      } finally {
        this.isLoading = false;
      }
    },

    async deleteCustomer() {
      let confirmDeleteModal = Modal.getInstance($('#confirmDeleteModal'));
      if(confirmDeleteModal && this.customerToDelete){
        await apiConnector.makeDeleteRequest('/products/'+this.customerToDelete.id);
        updatePageUrlWithSearch(currentPage(), this.sortField, this.sortOrder, this.searchInput);
        showToast('Customer successfully deleted.')
        confirmDeleteModal.hide();
      }
    },

    sortClicked(sorting) {
      this.sortField = sorting.column;
      this.sortOrder = sorting.order;
      updatePageUrlWithSearch(1, this.sortField, this.sortOrder, this.searchInput);
    },
    removeCustomerClicked(customer){
      this.customerToDelete = customer;
      $('.deleteModalCustomerName').html(customer.name);
    },
    formatTimestamp
  },
};
</script>
